import ApplicationController from "./application_controller.js"

export default class extends ApplicationController {

  assign(ev) {
    let user_id = ev.target.getAttribute('data-user-id')
    let answer_id = this.data.get('answer-id')
    if (answer_id) {
      // Assign a single answer
      $.post("/l/answers/" + answer_id, {_method: "put", answer: {assignee_id: user_id}})
    } else {
      // Assign an entire topic
      $.post("/l/documents/" + this.data.get('document-id') + "/assign_topic", {assignee_id: user_id, topic_id: this.data.get('topic-id')})
    }
    ev.preventDefault()
  }

  newUser() {
    $('#invite-and-flag-form').html($('#invite-and-flag-form-blank').html())
    $('#invite-and-flag-form form').attr('id', 'new_user')
    $('#invite-and-flag-form #new_user_assign_answer_id').val(this.data.get('answer-id'))
    $('#invite-and-flag-modal').modal({onApprove: () => false}).modal('show')
    initUI($('#invite-and-flag-form'))
  }

}
